"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LinkDefaultIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "nonzero",
    d: "M11.45 20.318l-1.06 1.06A5.5 5.5 0 012.61 13.6l6.011-6.01a3.625 3.625 0 015.127 0l2.21 2.21-1.945 1.944-1.768-1.767a1.5 1.5 0 00-2.121 0l-5.569 5.568a2.75 2.75 0 003.89 3.89l1.06-1.062 1.945 1.945zm1.114-16.646l1.061-1.061a5.5 5.5 0 017.778 7.778l-6.01 6.01a3.625 3.625 0 01-5.127 0l-2.21-2.21 1.945-1.944 1.768 1.768a1.5 1.5 0 002.121 0l5.569-5.568a2.75 2.75 0 00-3.89-3.89l-1.06 1.061-1.945-1.944z"
  }));
});
LinkDefaultIcon.category = 'Content';
var _default = LinkDefaultIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/LinkDefaultIcon.js
// module id = 1106
// module chunks = 0